var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-2 text-heading-2"},[_vm._v("\n  "+_vm._s(_vm.$t('label.search_results_for'))+"\n  '"),_c('em',[_vm._v(_vm._s(_vm.searchedQuery))]),_vm._v("'\n")])}
var staticRenderFns = []

export { render, staticRenderFns }